export const ADD_SMTP = 'ADD_SMTP'
